export enum TypeSections {
  Tasks = 'tasks',
  Habits = 'habits',
}

export enum DayPartSections {
  Overdue = 'overdue',
  AllDay = 'allDay',
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
}
